/**
 * Multi-word product search helpers.
 * Query "pochette bibo" must match "Pochette stylo a bille bibo"
 * (every token present somewhere in name/description/sku/barcode).
 */

/** Split on whitespace; drop empty tokens; lowercase. */
export function tokenizeProductSearchQuery(query: string): string[] {
  return query
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((t) => t.trim())
    .filter((t) => t.length > 0);
}

/** Build a lowercase haystack from common product search fields. */
export function buildProductSearchHaystack(fields: Array<string | null | undefined>): string {
  return fields
    .filter((f) => f != null && String(f).length > 0)
    .join(' ')
    .toLowerCase();
}

/** True when every query token appears in the haystack (order-independent). */
export function productSearchHaystackMatches(haystack: string, query: string): boolean {
  const tokens = tokenizeProductSearchQuery(query);
  if (tokens.length === 0) return true;
  const hay = haystack.toLowerCase();
  return tokens.every((token) => hay.includes(token));
}
